import React, { useState, FunctionComponent, useEffect } from "react"
import Button from "@murphy-frontend/web-core/components/Button"
import { FilterType } from "@murphy-frontend/web-core/components/FilterControl"
import FilterToggle from "@murphy-frontend/web-core/components/FilterToggle"
import MurphyDatePicker from "@murphy-frontend/web-core/components/MurphyDatePicker"

interface FilterProps {
	allFilters: FilterType[]
	closeModal: () => void
	toggleFilter: (filter: FilterType[], fromDate: Date, toDate: Date) => void
	reset: () => void
	translations: Record<any, any>,
	startDate: Date,
	endDate: Date
}

const Filters: FunctionComponent<FilterProps> = ({
	allFilters,
	closeModal,
	toggleFilter,
	reset,
	translations,
	startDate,
	endDate
}) => {
	const [filters, setFilters] = useState<FilterType[]>(allFilters);
	const [fromDate, setFromDate] = useState<Date>(startDate);
	const [toDate, setToDate] = useState<Date>(endDate);

	useEffect(() => {
		setFilters(allFilters)
	}, [allFilters])

	const handleSubmit = () => {
		toggleFilter(filters, fromDate, toDate)
		closeModal()
	}

	const handleFilter = (filter: FilterType) => {
		const updatedFilter = { ...filter, isActive: !filter.isActive }
		let updatedFilters = [...filters]
		const idx = updatedFilters.findIndex(row => row.displayName === filter.displayName)
		updatedFilters[idx] = updatedFilter
		setFilters(updatedFilters)
	}

	const handleClear = () => {
		reset()
		closeModal()
	}

	return (
		<div>
			<section>
				<div className='filters-header'>{'Filter for'}</div>
				<div className='filters-row'>
					{filters.map(filter => (
						<FilterToggle
							filterName={filter.displayName}
							key={filter.displayName}
							checked={filter.isActive}
							handleClick={() => handleFilter(filter)}
						/>
					))}
				</div>
				<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10 }}>
					<p style={{ marginRight: 10 }}>From</p>
					<MurphyDatePicker
						title={translations.date}
						isControlled={false}
						name="fromDate"
						locale="sv"
						showTime={false}
						errorMessage={''}
						maxDate={toDate || new Date()}
						onChange={(date: Date) => setFromDate(date)}
						selected={fromDate}
						showClearIcon={true}
						onClickClear={() => setFromDate(undefined)}
					/>
					<p style={{ marginRight: 10, marginLeft: 10 }}>to</p>
					<MurphyDatePicker
						title={translations.date}
						isControlled={false}
						name="toDate"
						locale="sv"
						showTime={false}
						errorMessage={''}
						minDate={fromDate || null}
						maxDate={new Date()}

						onChange={(date: Date) => setToDate(date)}
						selected={toDate}
						showClearIcon={true}
						onClickClear={() => setFromDate(undefined)}
					/>
				</div>

			</section>
			<section className='flex-container-full-width row filter-button-container'>
				<Button onClick={handleSubmit}>{translations.save}</Button>
				<Button buttonStyle={"btn--outline"} isClearButton={true} onClick={handleClear}>
					{translations.clearall}
				</Button>
			</section>
		</div>
	)
}

export default Filters;
